import { useState, useEffect } from 'react';

const useLanguageOptions = (endpoint = '') => {
  const [languageOptions, setLanguageOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await fetch(`/rapi/user/languageoptions/${endpoint}`);
        if (!response.ok) throw new Error('Failed to fetch language options');

        const data = await response.json();

        const fetchedLanguages = data.map(lang => ({
          label: lang.name,
          value: lang.code
        }));

        setLanguageOptions(fetchedLanguages);
      } catch (error) {
        console.warn('API error: Failed to fetch language options', error);
        setLanguageOptions([]); // Tom lista om det misslyckas
      } finally {
        setLoading(false);
      }
    };

    fetchLanguages();
  }, [endpoint]);

  return { languageOptions, loading };
};

export default useLanguageOptions;
